import { z } from 'zod';
import { IsoDateSchema } from './common';

export const ImputationTypeSchema = z.enum(['estructura', 'cliente']);
export type ImputationType = z.infer<typeof ImputationTypeSchema>;

export const EXPENSE_CATEGORIES = [
  'Software',
  'Servicios externos',
  'Suministros',
  'Material',
  'Marketing',
  'Comisiones',
  'Otros',
] as const;

export const ExpenseCategorySchema = z.enum(EXPENSE_CATEGORIES);
export type ExpenseCategory = z.infer<typeof ExpenseCategorySchema>;

export const CreateInvoiceReceivedSchema = z
  .object({
    supplier: z.string().min(1),
    reference: z.string().nullish(),
    date: IsoDateSchema,
    category: ExpenseCategorySchema,
    baseAmount: z.number().min(0),
    ivaAmount: z.number().min(0).default(0),
    totalAmount: z.number().min(0),
    imputationType: ImputationTypeSchema,
    clientId: z.string().uuid().nullish(),
    hasAttachment: z.boolean().default(false),
    // Admin-only; ignored when set by a non-admin actor.
    isPrivate: z.boolean().optional(),
  })
  .refine(
    (v) =>
      (v.imputationType === 'estructura' && !v.clientId) ||
      (v.imputationType === 'cliente' && !!v.clientId),
    { message: 'clientId must be set iff imputationType=cliente' },
  );
export type CreateInvoiceReceivedRequest = z.infer<typeof CreateInvoiceReceivedSchema>;

export const UpdateInvoiceReceivedSchema = z
  .object({
    supplier: z.string().min(1).optional(),
    reference: z.string().nullish(),
    date: IsoDateSchema.optional(),
    category: ExpenseCategorySchema.optional(),
    baseAmount: z.number().min(0).optional(),
    ivaAmount: z.number().min(0).optional(),
    totalAmount: z.number().min(0).optional(),
    imputationType: ImputationTypeSchema.optional(),
    clientId: z.string().uuid().nullish(),
    hasAttachment: z.boolean().optional(),
    // Admin-only; ignored when set by a non-admin actor.
    isPrivate: z.boolean().optional(),
  });
export type UpdateInvoiceReceivedRequest = z.infer<typeof UpdateInvoiceReceivedSchema>;
